import { render, staticRenderFns } from "./SWLogo.vue?vue&type=template&id=940cffe6&scoped=true&"
import script from "./SWLogo.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SWLogo.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940cffe6",
  null
  
)

export default component.exports